import { Injectable } from '@angular/core';

import { abastecimentosRoute } from "./data.service";
import { AuthService } from "../../shared/services/auth.service";

@Injectable()
export class AbastecimentoService {

    constructor(
        private _authService: AuthService
    ) { }

    goToSetting() {
        var router: string = abastecimentosRoute + '/configuracoes';
        this._authService.navigateTo(router);
    }

    goToReports() {
        var router: string = abastecimentosRoute + '/relatorios';
        this._authService.navigateTo(router);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/shared/abastecimento.service.ts
 **/